import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import "./DashBaordCard.css";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
export const DashboardCard = ({ Title, Total, To }) => {
  return (
    <Paper className="Card Flex">
      <Box className="UpperSection">
        <Typography className="TitleText">
          {Title}
        </Typography>
        <Typography className="TotalText">
          {Total}
        </Typography>
      </Box>
      <Box className="LowerSection">
        <Link className="LinkContent" to={To}>
          <Typography className="LinkText">
            View All {Title.split(" ")[1]}
          </Typography>
          <KeyboardArrowRightIcon className="arrow" />
        </Link>
      </Box>
    </Paper>
  );
};